import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC, useState } from 'react';
import dayjs from 'dayjs';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Image } from '../../../components/Image';
import { FONTS } from '../../../constants';
import { Calendar } from '../../../components/Calendar';

interface DatePickerProps {
  daySelect?: string;
  onDayChange?: (day: string) => void;
  placeholder?: string;
  showOn?: 'left' | 'right';
}

const DatePicker: FC<DatePickerProps> = ({
  daySelect,
  onDayChange,
  placeholder = '',
  showOn = 'left',
}) => {
  const [showCalendar, setShowCalendar] = useState<boolean>(false);

  return (
    <View style={{flex: 1}}>
      <TouchableOpacity
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingHorizontal: 10,
          paddingVertical: 10,
          alignItems: 'center',
          flex: 1,
          borderWidth: 1,
          borderColor: STYLE_VARS.fccDarkGrey,
        }}
        onPress={setShowCalendar.bind(null, !showCalendar)}
      >
        <Text
          style={{
            color: STYLE_VARS.fccDarkGrey,
            textTransform: 'uppercase',
            fontFamily: FONTS.AvenirMedium,
            fontSize: 13,
            fontWeight: '500',
          }}
        >
          {daySelect ? dayjs(daySelect).format('DD/MM/YYYY') : placeholder}
        </Text>
        <Image
          source={require('../../../assets/calendar-picker-icon.png')}
          style={{
            width: 16,
            height: 16,
            resizeMode: 'contain',
            marginLeft: 10,
          }}
        />
      </TouchableOpacity>
      {showCalendar && (
        <View
          style={[
            {
              zIndex: 100,
              width: 250,
              position: 'absolute',
              backgroundColor: '#EEEEEE',
              top: 40,
            },
            showOn === 'left' && {
              left: 0,
            },
            showOn === 'right' && {
              right: 0,
            }
          ]}
        >
          <Calendar
            setShowCalendar={setShowCalendar}
            showCalendar={showCalendar}
          />
        </View>
      )}
    </View>
  );
};

export default DatePicker;
